import './Subnavigation.scss'

import {LinkType, TranslationsType} from '../../types'
import React, {useState} from 'react'

import {Icon} from 'views/ui/Icon'
import {Languages} from './Languages'
import {Navlinks} from './Navlinks'
import {SearchPopup} from './search/SearchPopup'
import {Theme} from 'views/Theme'
import {style} from '../../util/style'
import {useTranslation} from '../../util/i18n'

const styles = style('subnavigation', ['nav'])

export type SubnavigationType = {
	subnavigation: Array<LinkType>
	translations: TranslationsType
}

export const Subnavigation: React.FC<SubnavigationType> = ({
	subnavigation,
	translations
}) => {
	const [search, setSearch] = useState(false)
	const t = useTranslation()

	return (
		<div className={styles()}>
			<Theme.Container>
				<div className={styles('content')}>
					{subnavigation && subnavigation.length > 0 && (
						<Navlinks styles={styles.nav} links={subnavigation} />
					)}
					<Languages
						className={styles('content-languages')}
						translations={translations}
					/>
					<button
						title={t.search.search}
						onClick={() => setSearch(!search)}
						className={styles('content-search')}
					>
						<Icon icon="search" />
					</button>
					<SearchPopup
						open={search}
						setOpen={setSearch}
						onClose={() => setSearch(!search)}
					/>
				</div>
			</Theme.Container>
		</div>
	)
}
